import React from 'react';

const Products = ({ className = '' }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M16.5 5.25L13.1667 6.91667M13.1667 6.91667L12.75 7.125L9.00002 9M13.1667 6.91667V9.83334M13.1667 6.91667L5.25002 2.75001M9.00002 9L1.50002 5.25M9.00002 9V16.9167M11.9817 1.81834L13.6484 2.69334C15.4409 3.63417 16.3375 4.10417 16.8359 4.95C17.3334 5.795 17.3334 6.84751 17.3334 8.95167V9.04917C17.3334 11.1525 17.3334 12.205 16.8359 13.05C16.3375 13.8958 15.4409 14.3667 13.6484 15.3075L11.9817 16.1817C10.5184 16.9492 9.78669 17.3333 9.00002 17.3333C8.21335 17.3333 7.48169 16.95 6.01835 16.1817L4.35169 15.3067C2.55919 14.3658 1.66252 13.8958 1.16419 13.05C0.666687 12.205 0.666687 11.1525 0.666687 9.05001V8.9525C0.666687 6.84834 0.666687 5.79584 1.16419 4.95084C1.66252 4.105 2.55919 3.63417 4.35169 2.69417L6.01835 1.81917C7.48169 1.05084 8.21335 0.666672 9.00002 0.666672C9.78669 0.666672 10.5184 1.05001 11.9817 1.81834Z"
        stroke="currentColor"
        strokeWidth="1.04"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default Products;
